// extracted by mini-css-extract-plugin
module.exports = {"modal":"style_modal__JYmlS","modalContentContainer":"style_modalContentContainer__3f7tD","permissionFormGroup":"style_permissionFormGroup__31fIs"};